import ResponseDataExtractor from '../../../../common/utils/ResponseDataExtractor';
import helper from '../../../../helper';

export default {
    getCancellationSetting({
        commit
    }) {
        commit('SET_PAGE', { loading: true });
        axios.get(process.env.MIX_API_URL + 'cms/booking-setting/cancellation-setting')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                //response 200
                commit('SET_CANCELLATION_SETTING', data.list[0] || null); 
                commit('SET_PAGE', {
                    loading: false
                });
            })
            .catch(() => {
                console.log('Error when get cancellation setting from api');
                commit('SET_PAGE', {
                    loading: false
                });
            });

    },
	requestCancellationProcess({
        commit
    }, data) {
        commit('SET_PAGE', { loading: true });
        axios.post(process.env.MIX_API_URL + 'cancel-booking', {
                ...data
            })
            .then(response => new ResponseDataExtractor(response).data)
            .then(_ => {
                //response 200
                commit('SET_VALIDATE_REQUEST_CANCELLATION_RESULT'); 
                commit('SET_PAGE', {
                    loading: false
                });
            })
            .catch(e => {
                const error = helper.errorCatch(e);
                commit('SET_VALIDATE_REQUEST_CANCELLATION_RESULT', error);
                commit('SET_PAGE', {
                    loading: false
                });
            });

    },
    clearValidateRequestCancellationResult({commit}){
        commit('SET_VALIDATE_REQUEST_CANCELLATION_RESULT', null);
    }
}